<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless">
    <div class="column is-12 is-paddingless hauteur-haut-panier">
      <div class="column is-12">
        <error-msg-component :messages="errors"
                             :error="errors.length > 0"
                             :title="'editionClient.problemOccurred'"
                             :withEmplyFields="true"
                             @close="errors = []"/>
      </div>
      <div class="column is-12 pdb-0">
        <a @click="togglePanier()">
          <b-icon class="icon is-pulled-right has-text-icon-more"
            icon="close"></b-icon>
        </a>
        <span class="mgl-10px has-text-weight-bold is-size-4">
          {{$t('ajoutDevis.panier')}}
        </span>
      </div>

      <div class="column is-12 pdb-0">
        <span class="mgl-10px is-size-6">
          {{returnNbProduitsPanier}}
        </span>
      </div>
      <div class="column is-12 border-entete">
        <span class="mgl-10px is-size-6 has-text-weight-bold">
          {{$t('ajoutDevis.total')}}
        </span>
        <div class="is-pulled-right">
          <span class="is-size-6 has-text-weight-bold">
            {{returnValeurPanier | formatDevise}}
          </span>
          <span class="is-size-6">
            {{budgetMax}}
          </span>
        </div>
      </div>

    </div>
    <div class="column is-12-tablet hauteur-panier is-marginless"
      v-if="calculNbrPeriode > 0">
      <div class="overflow-auto">
        <b-field>
          <div class="mgl-10px has-text-weight-bold mg-auto">
            {{ $t('detailPlanningNumerique.panier.newSelection') }}
          </div>
          <div>
            <button class="button is-size-7" @click="clearSelection">
              {{ $t('detailPlanningNumerique.panier.clearSelection') }}
            </button>
          </div>
        </b-field>
        <div v-for="produit in panier" :key="produit.id">
          <div v-for="periode in produit.periode" :key="periode.dateDebut.valueOf()"
            class="mgt-10px has-background-background">
            <div class="columns is-vcentered shadow is-marginless">
              <div class="panier-imgProduit column is-narrow is-paddingless is-flex">
                <img :src="produit.logo"
                  class="panier-imgProduit-logo" v-if="produit.logo"/>
                <div v-else>
                  <div :class="[
                    {'panier-imgProduit-reseauNumerique':
                    typeProduit === reseauNumerique},
                    {'panier-imgProduit-ecranNumerique': typeProduit === ecranNumerique}
                  ]"/>
                </div>
              </div>
              <div class="column mgl-10px is-paddingless">
                <p class="has-text-link is-size-6 ellipsis has-text-weight-bold textPanier">
                  {{produit.reference}}
                </p>
                <p class="has-text-default is-size-7 ellipsis textPanier">
                  {{returnPeriode(periode)}}
                  <span class="is-italic">
                    {{ $t('ajoutDevis.saturationLabelPanier', { saturation: periode.saturation }) }}
                  </span>
                </p>
                <p class="has-text-icon-more is-size-7 ellipsis textPanier">
                  {{returnLibelleProduitLocEtPrix(periode)}}
                </p>
              </div>
              <div class="column is-narrow">
                <a @click="supprimer(produit, periode)">
                  <b-icon
                    icon="delete-forever"
                    type="is-danger">
                  </b-icon>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="column is-12 hauteur-panier is-flex" v-else>
      <div class="has-text-centered mg-auto">
        <div class="logo__panier_vide mg-auto"></div>
        <p class="has-text-weight-bold is-size-5">{{$t('ajoutDevis.panierVide')}}</p>
        <p>{{$t('ajoutDevis.selectionnerProduit')}}</p>
      </div>
    </div>
    <div class="column is-12 hauteur-bas-panier border-pied
    columns is-marginless is-vcentered level">
      <div class="level-left">
        <div class="column is-narrow" v-if="calculNbrPeriode > 1 && canMakeReseauPerso">
          <b-checkbox v-model="regroupementPersonnalise">
          <span class="has-text-default is-size-6">
            {{$t('ligneRegroupementPersonnalisee.planning')}}
          </span>
          </b-checkbox>
        </div>
      </div>
      <button class="button pdv-0 column is-narrow pdh-20px
      level-right"
        :class="[{'is-select pointer-events-none': calculNbrPeriode === 0},
        {'is-addOrEdit': calculNbrPeriode > 0}]"
        @click="ajouterAuxLignes()">
          {{$t('ajoutDevis.actions.add')}}
      </button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import inProgress from '@/services/general/inProgress';
import formatDate from '@/services/general/formatDate';
import * as typesProduitNumerique from '@/store/modules/produitEcranNumerique-mutation-type';
import * as produitConf from '@/configuration/catalogue/produitConf';
import { formatDevise } from '@/services/general/filters/formatDevise';
import errorMsgComponent from '@/components/general/errorMsgComponent';

const Commande = createNamespacedHelpers('commande');
const produitNumerique = createNamespacedHelpers('produitEcranNumerique');

export default {
  name: 'DevisCommandesPanier',
  components: {
    errorMsgComponent,
  },
  props: {
    canMakeReseauPerso: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      reseauNumerique: produitConf.CATEGORIE_REGROUPEMENT_NUMERIQUE,
      ecranNumerique: produitConf.CATEGORIE_ECRAN_NUMERIQUE,
      typeProduit: this.$route.params.typeProduit,
      errors: [],
      tarifs: [],
    };
  },
  computed: {
    ...Commande.mapGetters({
      commandeCourante: 'commande',
    }),
    ...produitNumerique.mapGetters({
      panierGetter: 'panier',
      briefStocke: 'brief',
      getRegroupementPersonnalise: 'regroupementPersonnalise',
    }),
    regroupementPersonnalise: {
      set(value) {
        this.setGegroupementPersonnalise(value);
      },
      get() {
        return this.getRegroupementPersonnalise;
      },
    },
    calculNbrPeriode() {
      let nombrePeriode = 0;
      this.panier.forEach((el) => {
        nombrePeriode += el.periode.length;
      });
      return nombrePeriode;
    },
    budgetMax() {
      if (this.briefStocke.budgetMax !== null) {
        return `/ ${formatDevise(this.briefStocke.budgetMax)}`;
      }
      return '';
    },
    panier() {
      this.loadLogoPanier();
      return Object.values(this.panierGetter);
    },
    returnNbProduitsPanier() {
      const nombrePeriode = this.calculNbrPeriode;
      if (nombrePeriode === 0) {
        return this.$t('ajoutDevis.panierVide');
      }
      return this.$t('ajoutDevis.produitPanier', { nbProduits: nombrePeriode });
    },
    returnValeurPanier() {
      let prix = 0;
      this.panier.forEach((el) => {
        el.periode.forEach((p) => {
          prix = p.prix + prix;
        });
      });
      return prix;
    },
  },
  methods: {
    ...produitNumerique.mapMutations({
      deletePeriod: typesProduitNumerique.DELETE_PERIOD,
      setGegroupementPersonnalise: typesProduitNumerique.SET_REGROUPEMENT_PERSONNALISE,
    }),
    clearSelection() {
      if (this.panier[0].periode.length === 0) this.panier.splice(0, 1);
      if (this.panier.length === 0) return;
      this.deletePeriod({
        periode: [this.panier[0].periode[0]],
        produitId: this.panier[0].produitId,
      });
      this.clearSelection();
    },
    supprimer(produit, periode) {
      const data = {
        periode: [
          periode,
        ],
        produitId: produit.produitId,
      };
      this.deletePeriod(data);
    },
    ...produitNumerique.mapActions({
      loadLogoPanier: 'loadLogoPanier',
    }),
    returnLibelleProduitLocEtPrix(periode) {
      if (periode.prix === null) return periode.produitLocationNum.libelle;
      return `${periode.produitLocationNum.libelle} - ${formatDevise(periode.prix)}`;
    },
    ...produitNumerique.mapMutations({
      clearBrief: typesProduitNumerique.CLEAR_BRIEF,
      clearPanier: typesProduitNumerique.CLEAR_PANIER,
    }),
    togglePanier() {
      this.$emit('togglePanier');
    },
    ajouterAuxLignes() {
      if (this.calculNbrPeriode === 1) {
        this.regroupementPersonnalise = false;
      }
      this.$emit('ajouterAuxLignes');
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    returnPeriode(periode) {
      if (periode.dateDebut === periode.dateFin) return formatDate(periode.dateDebut);
      return this.$t('ajoutDevis.au', { dateDebut: formatDate(periode.dateDebut), dateFin: formatDate(periode.dateFin) });
    },
  },
  mounted() {
    if (this.panier.length === 0) {
      return;
    }
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.regroupementPersonnalise = true;
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style lang="scss" scoped>

</style>
